var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-group btn-word-yellow",on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon',{staticClass:"icon-image",attrs:{"image":_vm.image}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }